import React from "react"
import { useDispatch } from "react-redux"
import { useParams } from "react-router-dom"
// ## //
import { Box } from "@material-ui/core"
import LoginText from "../login/LoginText"
import auth from "../../api/authSlice"
import ChangePasswordForm from "./ChangePasswordForm"
import useLoginStyles from "../login/loginStyle"

const FirstUserConnectionPage = () => {
  const classes = useLoginStyles()
  const dispatch = useDispatch()
  const { token } = useParams()
  const { actions } = auth

  /**
   * Validate registration and create user account from backend service.
   * Then login user automatically, and redirect into its private space.
   * @param values
   */
  const handleSubmit = (values) => {
    return dispatch(actions.register(token, values))
  }

  return (
    <Box className={classes.loginWrapper}>
      <LoginText />
      <Box display="flex" alignItems="center" className={classes.loginForm}>
        <ChangePasswordForm handleSave={handleSubmit} register />
      </Box>
    </Box>
  )
}

FirstUserConnectionPage.propTypes = {}
FirstUserConnectionPage.defaultProps = {}

export default FirstUserConnectionPage
